import React, { useEffect, useState, useRef } from "react";
import { Grid } from "@material-ui/core";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import ReactPlayer from "react-player";
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import QuizIcon from "@mui/icons-material/Quiz";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardContent";
import Checkbox from '@mui/material/Checkbox';
//import { useCustomTheme } from "../api/ThemeProvider";
import "../styles/devices/mob_DataSet.css";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { pDatasetBuilderStates } from "../utils/parameters";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { CompareVideosDialogs } from "../components/dialog/CompareVideosDialogs";
import { Tooltip } from '@material-ui/core';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import Paper from "@mui/material/Paper";


// MOB - There were 6 indexes but only 5 values indicated. I added "box_comment_extra", following the structure of the next pre-existing lines
// [video, btn_repeat, btn_confirm, btn_other, box_comment_extra, btn_ error]
const btns_datasetbuilder_default = [false, false, false, false, false, false];
const pos_video = 0;
const pos_btn_repeat = 1;
const pos_btn_confirm = 2;
const pos_btn_other = 3;
const pos_box_comment_extra = 4;
const pos_btn_error = 5; /* MOB - Deactivate? It is never used */

export function DatasetBuilder() {
  const [state, setState] = useState(pDatasetBuilderStates.idle);
  const [btns_datasetbuilder, setBtns_datasetBuilder] = useState(btns_datasetbuilder_default);
  const { token_id, currentUser, json_data_USER } = useDataProvider();
  const [list_session, setList_session] = useState([]);
  const { comm_requestVideoDatasetBuilder, comm_sendDatasetBuilder, comm_getDatasetBuilder } = useCommProvider();
  const [annotation, setAnnotation] = useState("");
  const [ videoAnnotation, setVideoAnnotation ] = useState(null);
  // const [annotation_code, setAnnotation_code] = useState("");
  const [annotation_code, setAnnotation_code] = useState([]);
  const comment_ref = useRef("");


  const [videoLoaded, setVideoLoaded] = useState(null);

  const videoLoaded_ref = useRef(null);
  const session_ref = useRef("");
  const filename_ref = useRef("");
  // const list_classes_ref = useRef([]);
  // const list_vid_url_ref = useRef([]);

  const dict_classes_label_url_ref = useRef({});

  const list_annotation_codes_ref = useRef([]);
  const session_url_ref = useRef(""); // Signamed YT:   https://www.youtube.com/watch?v=MyBO7Cg7dUA
  const info_ref = useRef("");
  const counter_repeats_used_ref = useRef(0);
  const historyLog_ref = useRef("");

  const [openCompareVideos, setOpenCompareVideos] = useState(false);
  const [activateCompareVideos, setActivateCompareVideos] = useState(true);
  const [speedCompareVideos, setSpeedCompareVideos] = useState(1);

  const [num_annotated_videos, setNum_annotated_videos] = useState(0);
  const [num_total_videos, setNum_total_videos] = useState(0);
  const [arr_counters, setArr_counters] = useState({});

  const edit_annotation_idx_ref = useRef(null);

  function annotation_contains_coments_option(annotation_code) {
    let activate_comment_box = false
    annotation_code.forEach(element => {
      if (list_annotation_codes_ref.current[element] === "Otro comentario") {
        activate_comment_box = true
      }
    });
    return activate_comment_box
  }

  useEffect(() => {    
    switch (state) {
      case pDatasetBuilderStates.init:
        setBtns_datasetBuilder([false, false, false, false, false, false]);
        break;
      case pDatasetBuilderStates.init_request:
        setBtns_datasetBuilder([false, false, false, false, false, true]);
        break;
      case pDatasetBuilderStates.runVideo:
        setBtns_datasetBuilder([true, false, false, false, false, false]);
        break;
      case pDatasetBuilderStates.idle:
        if (annotation === "" && annotation_code.length === 0) {
          setBtns_datasetBuilder([false, true, false, true, false, false]);
        } else {
          //if (list_annotation_codes_ref.current[annotation_code] === "Otro comentario") {
          if (annotation_contains_coments_option(annotation_code)) {
            setBtns_datasetBuilder([false, true, true, true, true, false]);
          } else {
            setBtns_datasetBuilder([false, true, true, true, false, false]);
          }
        }
        break;
      default:
        break;
    }
  }, [state, annotation_code, annotation]);

  useEffect(() => {
    if (json_data_USER["arr_dataset_builder"]!==undefined) {
      setList_session(json_data_USER["arr_dataset_builder"]);
    }
  }, [json_data_USER]);

  function obtain_info_comment_box() {
    let comment = "";
    if (btns_datasetbuilder[pos_box_comment_extra] === true) {
      comment = comment_ref.current.value;
      // comment_ref.current.value = "";
    }
    return comment;
  }

  function format_annotation_code(annotation_code){
    let annotation_code_str = "";
    for (let i = 0; i < annotation_code.length; i++) {
      annotation_code_str = annotation_code_str + annotation_code[i] + ",";
    }
    if (annotation_code_str.length == 0) {
      return ""
    }
    return annotation_code_str;
  }

  async function getServerDatasetBuilder(session, edit_annotation_idx) {
    setState(pDatasetBuilderStates.init_request);
    setVideoLoaded(null);

    if (session !== "") {
      const response = await comm_getDatasetBuilder(token_id, currentUser, session, edit_annotation_idx);
      console.log("🚀 ~ getServerDatasetBuilder ~ response:", response)
      refreshDatasetBuilder(session, response["filename"], response["class_ref"], response["info"], response["classes"], response["annotation_codes"], response["session_url"], response["previous_annotation"]);
      // setAnnotation(response["previous_annotation"]["class_id"]);
      // setAnnotation_code(response["previous_annotation"]["annotation_code"]);
      // comment_ref.current = response["previous_annotation"]["comment"];
    }
  }


  async function send2ServerDatasetBuilder(session, filename = "", class_id = -1, annotation_code_id = [], repeats_used = 0, historyLog = "") {
    setState(pDatasetBuilderStates.init_request);
    setVideoLoaded(null);
    // videoLoaded_ref.current = null;
    if (session !== "") {
      //const response = await postmanSendDatasetBuilder(uid, session, filename, class_id, format_annotation_code(annotation_code_id), obtain_info_comment_box(), repeats_used, historyLog);
      let response = ""
      if (editModeIsActive()){
        response = await comm_sendDatasetBuilder(token_id, currentUser, session, filename, class_id, format_annotation_code(annotation_code_id), obtain_info_comment_box(), repeats_used, historyLog, edit_annotation_idx_ref.current );
      }else{
        response = await comm_sendDatasetBuilder(token_id, currentUser, session, filename, class_id, format_annotation_code(annotation_code_id), obtain_info_comment_box(), repeats_used, historyLog, -1);
      }

      console.log("🚀 ~ getServerDatasetBuilder ~ response:", response)

      refreshDatasetBuilder(session, response["filename"], response["class_ref"], response["info"], response["classes"], response["annotation_codes"], response["session_url"]);
      
      setNum_total_videos(response["len_arr_all_data"]);
      setArr_counters(response["arr_counters"]);
      setNum_annotated_videos(response["len_arr_user_data"]);
      edit_annotation_idx_ref.current=response["len_arr_user_data"];
    }
  }

  async function send2ServerDownloadFilename(session, filename) {
    setVideoLoaded(await comm_requestVideoDatasetBuilder(token_id, currentUser, session, filename));
    filename_ref.current = filename;
    // videoLoaded_ref.current = video;
    counter_repeats_used_ref.current = 0;

    if (filename.length > 1 && historyLog_ref.length > 1) {
      historyLog_ref.current = historyLog_ref.current + "," + filename;
    } else {
      historyLog_ref.current = filename;
    }

    setState(pDatasetBuilderStates.runVideo);
  }

  function refreshDatasetBuilder(session, filename, class_input, info, classes, annotation_codes, session_url, previous_annotation=undefined) {

    // list_classes_ref out
    // list_vid_url_ref out

    // use::
    // dict_classes_label_url_ref


    // list_classes_ref.current = classes;

    // Array para almacenar los datos extraídos
    dict_classes_label_url_ref.current = {};
    
    classes.forEach((element, index) => {
      // Dividir cada elemento en datos y URL utilizando la coma como separador
      const [data, url] = element.split(',');

      // Añadir los datos al array array_data
      dict_classes_label_url_ref.current[data]= {
        'index': index,
        'url': url || null
      }
      // list_classes_ref.current.push(data);
      // list_vid_url_ref.current.push(url || null);
    });

    // Get key of dict_classes_label_url_ref with the field 'index' with a value equal to requested_index
    list_annotation_codes_ref.current = annotation_codes;
    info_ref.current = info;

    session_url_ref.current = session_url;

    if (previous_annotation !== undefined){
      // previous_annotation is a index of array classes
      try{
        const [data, url] = classes[parseInt(previous_annotation["class_id"])].split(','); 
        setAnnotation(data);
        setVideoAnnotation(url);
      }catch{
        setAnnotation("");
        setVideoAnnotation(null);
      }
      setAnnotation_code(previous_annotation["annotation_code"]);
      comment_ref.current = previous_annotation["comment"];
    }else{
      try{
        const [data, url] = classes[parseInt(class_input)].split(','); 
        setAnnotation(data);
        setVideoAnnotation(url);
      }catch{
        setAnnotation("");
        setVideoAnnotation(null);
      }
      setAnnotation_code([]);
    }

    send2ServerDownloadFilename(session, filename);
  }

  useEffect(() => {
    if (activateCompareVideos === true && videoAnnotation !== null && videoLoaded !== null) {
      setOpenCompareVideos(true)
    }
    
  },[videoLoaded, videoAnnotation]);


  async function clickSession(event) {
    const session_selected = event.target.value;
    session_ref.current = session_selected;
    send2ServerDatasetBuilder(session_selected);
    setState(session_selected);
  }


  function btn_Send_Server() {
    let annotation_idx_send = annotation;
    try{
      annotation_idx_send = dict_classes_label_url_ref.current[annotation].index;
    }catch{
      annotation_idx_send = -1;
    }

    send2ServerDatasetBuilder(session_ref.current, filename_ref.current, annotation_idx_send, annotation_code, counter_repeats_used_ref.current, historyLog_ref.current);
    setOpenCompareVideos(false)
  }

  function btn_Jump() {
    send2ServerDatasetBuilder(session_ref.current);
    setOpenCompareVideos(false)
  }

  function btn_Discard() {
    send2ServerDatasetBuilder(session_ref.current, filename_ref.current, -1, []);
  }

  const clickAnnotation = (event) => {
    setAnnotation(event.target.value);
    try{
      setVideoAnnotation(dict_classes_label_url_ref.current[event.target.value].url);
    }catch{
      setVideoAnnotation(null);
    }
  };

  const clickCode = (event) => {
    const {
      target: { value },
    } = event;
    
    setAnnotation_code(
      typeof value === 'string' ? value.split(',') : value.filter(numero => numero !== ""),
    );
  };

  const clickBtnRepeat = (event) => {
    setState(pDatasetBuilderStates.runVideo);
    counter_repeats_used_ref.current = counter_repeats_used_ref.current + 1;
  };

  const endVideo = (event) => {
    setState(pDatasetBuilderStates.idle);
    // setStatusPlayer(pDatasetBuilderStates.runVideo)
  };

  const showHelpIcon = () => {
    // if (url_description.current.length>0){
    if (session_ref.current.length > 0) {
      const newWindow = window.open(session_url_ref.current, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };

  const showComparationVideos = () => {
    if (activateCompareVideos === false) {
      setActivateCompareVideos(true)
      setOpenCompareVideos(true)
    }else{
      setActivateCompareVideos(false)
      setOpenCompareVideos(false)
    }
  };

  const handleCloseDialog = () => {
    setOpenCompareVideos(false)
  };

  const clickBtnNext = () => {
    setActivateCompareVideos(false)

    const new_edited_annotation_idx = edit_annotation_idx_ref.current  + 1
    edit_annotation_idx_ref.current = new_edited_annotation_idx
    handleBtnEditMode(new_edited_annotation_idx)
  };

  const clickBtnBack = () => {
    setActivateCompareVideos(false)

    const new_edited_annotation_idx = edit_annotation_idx_ref.current  - 1
    edit_annotation_idx_ref.current = new_edited_annotation_idx
    handleBtnEditMode(new_edited_annotation_idx)
  };


  function handleBtnEditMode(new_edited_annotation_idx){
    if (new_edited_annotation_idx < num_annotated_videos ) {
      getServerDatasetBuilder(session_ref.current, new_edited_annotation_idx)
    } else {
      send2ServerDatasetBuilder(session_ref.current);
    }
  }

  function editModeIsActive(){
    if (edit_annotation_idx_ref.current < num_annotated_videos ) {
      return true
    } else
      return false
  }
    




  return (
    <HomeWrapper>
      <CompareVideosDialogs openDialog={openCompareVideos} requested_video={videoLoaded} selected_video={videoAnnotation} selected_label={annotation} speedCompareVideos={speedCompareVideos} setSpeedCompareVideos={setSpeedCompareVideos} handleClickClose={handleCloseDialog} btn_Send_Server={btn_Send_Server} btn_Jump={btn_Jump} showComparationVideos={showComparationVideos}/>

      <PageTitle title="ESTUDIOS" />
      <Grid className="sig_DataSet_Root" container>
        <Card className="sig_DataSet_CardContainer">
          <CardActionArea className={`sig_DataSet_CardActionArea ${session_ref.current !== "" ? "sig_DataSet_ExpandedArea" : ""}`}>
            <Grid className="sig_DataSet_ActionAreaContainer" container>
              <Grid className="sig_DataSet_ActionArea" item>
                <Grid className="sig_DataSet_ActionAreaColumn" container>
                  <Grid className="sig_DataSet_SetSelection" container>
                    <Grid className="sig_DataSet_SetSelection_FormContainer" item>
                      <FormControl className={`sig_DataSet_SetSelectionForm ${session_ref.current !== "" ? "" : "sig_DataSet_ExpandedForm"}`}>
                        <InputLabel>Sesion</InputLabel>
                        <Select className="sig_DataSet_MenuList" value={session_ref.current} label="Sesion" onChange={clickSession}>
                          <MenuItem className="sig_DataSet_MenuListItem" value="">
                            <em>Sin seleccionar</em>
                          </MenuItem>
                          {list_session.map((item) => {
                            return (
                              <MenuItem className="sig_DataSet_MenuListItem" key={item} value={item}>
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <div>
                      {session_ref.current !== "" && session_url_ref.current !== "" ? (
                        <Grid item>
                          {
                            <IconButton className="sig_DataSet_ButtonHelp" onClick={showHelpIcon}>
                              <QuizIcon fontSize="large" color="primary" />
                            </IconButton>
                          }
                        </Grid>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Grid>

                  <div>
                    {session_ref.current !== "" && Object.keys(dict_classes_label_url_ref.current).length > 0 ? (
                      <Grid item>
                        {
                          <ReactPlayer
                            className="sig_DataSet_ReactPlayer"
                            // url={[{ src: videoLoaded, type: "video/mp4" }]}
                            onEnded={endVideo}
                            url={videoLoaded}
                            controls={false}
                            playing={btns_datasetbuilder[pos_video]}
                            //playing = {true}
                            loop={false}
                          />
                        }
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="sig_DataSet_Div_VideoInfo">
                    {(session_ref.current && Object.keys(dict_classes_label_url_ref.current).length > 0) !== "" ? (
                      <Grid item>
                        
                        <Paper elevation={3} className="sig_VersusMachine_PaperInfo" style={{ width: '100%' }}>
                          <div>
                            {Object.entries(arr_counters).map(([key, value]) => (
                                <div key={key}>
                                  <span className="sig_VersusMachine_InfoTitle">Vid. con {key} anns: </span>
                                  <span className="sig_VersusMachine_InfoContent"> {value}</span>
                                </div>
                            ))}
                          </div>
                        </Paper>

                        <Button style={{}} onClick={clickBtnBack}>
                          {" "}
                          <ArrowCircleLeftRoundedIcon className={`sig_VersusMachine_Arrow_Button ${edit_annotation_idx_ref.current  == 0 ? "sig_VersusMachine_Arrow_Button_Hide" : ""}`} />{" "}
                        </Button>
                        <span style={{fontSize: '14px'}} className="sig_VersusMachine_Counter">{edit_annotation_idx_ref.current } de {num_annotated_videos}</span>
                        <Button onClick={clickBtnNext}>
                          <ArrowCircleRightRoundedIcon className={`sig_VersusMachine_Arrow_Button ${edit_annotation_idx_ref.current  == num_annotated_videos ? "sig_VersusMachine_Arrow_Button_Hide" : ""}`} />
                        </Button>

                    </Grid>
                    ) : (
                      <></>
                    )}
                  </div>
                </Grid>
              </Grid>
              <Grid className="sig_DataSet_ActionArea" item>

                {(session_ref.current && Object.keys(dict_classes_label_url_ref.current).length > 0) !== "" ? (
                  
                  <Grid className="sig_VersusMachine_ActionAreaColumn" container>

                    <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonRepeatContainer" item>
                      <Button className="sig_DataSet_ButtonRepeat" color="primary" variant="contained" disabled={!btns_datasetbuilder[pos_btn_repeat]} onClick={clickBtnRepeat}>
                        REPETIR VISUALIZACIÓN DEL VÍDEO
                      </Button>
                    </Grid>
                    <Grid item>
                      <FormControl className="sig_DataSet_Form sig_DataSet_FormAnotation">
                        <InputLabel>Anotación</InputLabel>
                        <Select className="sig_DataSet_MenuList" value={annotation} label="Anotación" onChange={clickAnnotation}>
                          <MenuItem className="sig_DataSet_MenuListItem" key={""} value="">
                            <em>Sin seleccionar</em>
                          </MenuItem>
                          {Object.keys(dict_classes_label_url_ref.current).sort().map((item, index) => {
                            return (
                              <MenuItem className="sig_DataSet_MenuListItem" key={index} value={item}>
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item>
                      <FormControl className="sig_DataSet_Form sig_DataSet_FormAnotation" /* sx={{minWidth: 400 }}*/>
                        <InputLabel>Comentario</InputLabel>
                        <Select className="sig_DataSet_MenuList" multiple value={annotation_code} label="Comentario" onChange={clickCode}>
                          <MenuItem className="sig_DataSet_MenuListItem" value="">
                            <em>Sin seleccionar</em>
                          </MenuItem>
                          {list_annotation_codes_ref.current.map((item, index) => {
                            return (
                              <MenuItem className="sig_DataSet_MenuListItem" key={item} value={index}>
                                <Checkbox checked={annotation_code.indexOf(index) > -1} />
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>

                    { editModeIsActive()===false ? (
                      <Grid item>
                      <Paper elevation={3} className="sig_VersusMachine_PaperInfo" style={{ width: '100%' }}>
                            <div style={{display: 'flex'}}>
                              <span className="sig_VersusMachine_InfoTitle">Modo express:</span>
                              {(activateCompareVideos) ? <span className="sig_VersusMachine_InfoContent"> ON </span> : <span className="sig_VersusMachine_InfoContent"> OFF </span>}
                              
                            
  
                      {(videoAnnotation !== null && annotation!=='') ? (
                        <>
                              {(activateCompareVideos) ?
  
                                <Tooltip 
                                  classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                                  placement="top"
                                  arrow
                                  interactive={true} 
                                  title={
                                    <div className="sig_CustomTooltip_Content">
                                      <p><strong> MODO EXPRESS: RÁPIDA CONFIRMACIÓN DE LOS VÍDEOS.</strong></p>
                                      <p> Desactivar.</p>
                                    </div>
                                  }>
                                  <IconButton className="sig_DataSet_ButtonHelp" onClick={showComparationVideos}>
                                    <PauseCircleOutlineIcon fontSize="large" color="error" />
                                  </IconButton>
                                </Tooltip>
                              :
                                <Tooltip 
                                  classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                                  placement="top"
                                  arrow
                                  interactive={true} 
                                  title={
                                    <div className="sig_CustomTooltip_Content">
                                      <p><strong> MODO EXPRESS: RÁPIDA CONFIRMACIÓN DE LOS VÍDEOS.</strong></p>
                                      <p> Activar dialogo de anotación en el que se te muestra el vídeo de referencia y el vídeo pendiente de anotar.</p>
                                      <p> De este modo puedes confirmar que la anotación es correcta de una forma más rápida.</p>
                                    </div>
                                  }>
                                  <IconButton className="sig_DataSet_ButtonHelp" onClick={showComparationVideos}>
                                    <PlayCircleOutlineIcon fontSize="large" color="success" />
                                  </IconButton>
                                </Tooltip>
                              }
                          </>) : (
                            <></>
                          )}
                          </div>
                      
                      </Paper>
                      </Grid>
                    ) : (
                      <Grid item>
                        <Paper elevation={3} className="sig_VersusMachine_PaperInfo" style={{ width: '100%' }}>
                        <div style={{display: 'flex'}}>
                          <span className="sig_VersusMachine_InfoTitle"> Modo edición activado</span>
                        </div>
                        </Paper>
                      </Grid>
                    )}
                    
                    
                    <Grid item>
                      {btns_datasetbuilder[pos_box_comment_extra] === true ? (
                        <TextField
                          className="sig_DataSet_TextComment"
                          autoFocus
                          //margin="dense"
                          id="name"
                          label="Comentario en texto"
                          inputRef={comment_ref}
                          defaultValue={comment_ref.current}
                        />
                      ) : (
                        <></>
                      )}
                    </Grid>
                    {editModeIsActive()===false ? (
                      <>
                        <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer" item>
                        <Button className="sig_DataSet_ButtonConfirm" variant="outlined" color="success" disabled={!btns_datasetbuilder[pos_btn_confirm]} onClick={btn_Send_Server}>
                          Confirmar
                        </Button>
                      </Grid>
                      <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonLaterContainer" item>
                        <Button className="sig_DataSet_ButtonLater" variant="outlined" color="secondary" disabled={btns_datasetbuilder[pos_btn_other] === false ? true : false} onClick={btn_Jump}>
                          Anotar este vídeo en otro momento
                        </Button>
                      </Grid>
                      <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonReportContainer" item>
                        {btns_datasetbuilder[pos_btn_other] === false ? (
                          <Button className="sig_DataSet_ButtonReport" variant="outlined" color="error" onClick={btn_Discard}>
                            REPORTAR PROBLEMA AL REPRODUCIR EL VIDEO
                          </Button>
                        ) : (
                          <></>
                        )}
                      </Grid>

                    </>

                    ) : (
                      <>
                      
                      <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer" item>
                        <Button className="sig_DataSet_ButtonConfirm" variant="outlined" color="success" disabled={!btns_datasetbuilder[pos_btn_confirm]} onClick={btn_Send_Server}>
                          Editar anotación
                        </Button>
                      </Grid>
                      <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonLaterContainer" item>
                        <Button className="sig_DataSet_ButtonLater" variant="outlined" color="secondary" disabled={btns_datasetbuilder[pos_btn_other] === false ? true : false} onClick={btn_Jump}>
                          Borrar anotación
                        </Button>
                      </Grid>

                      </>
                      
                    )
                     
                    }
                    
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </CardActionArea>
        </Card>
      </Grid>
    </HomeWrapper>
  );
}
